import type { IRegisterUserMediaAssetPayload, IUserMediaAsset } from '../types/global/userMedia.types';

export function readImageDimensions(file: File): Promise<{ width: number | null; height: number | null }> {
    if (!file.type.startsWith('image/') || file.type === 'image/svg+xml') {
        return Promise.resolve({ width: null, height: null });
    }
    return new Promise(resolve => {
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
            URL.revokeObjectURL(url);
            resolve({ width: img.naturalWidth || null, height: img.naturalHeight || null });
        };
        img.onerror = () => {
            URL.revokeObjectURL(url);
            resolve({ width: null, height: null });
        };
        img.src = url;
    });
}

export function unwrapUserMediaData<T>(response: { data?: { data?: T } & T }): T {
    return (response.data?.data ?? response.data) as T;
}

export function normalizeRegisteredUserMediaAsset(
    raw: Record<string, unknown>,
    fallback: IRegisterUserMediaAssetPayload,
): IUserMediaAsset {
    const id = String(raw.id ?? raw._id ?? fallback.file_key);
    return {
        id,
        user_id: raw.user_id != null ? String(raw.user_id) : undefined,
        name: String(raw.name ?? fallback.name),
        url: String(raw.url ?? fallback.url),
        file_key: String(raw.file_key ?? fallback.file_key),
        mime_type: (raw.mime_type as string | null) ?? fallback.mime_type ?? null,
        size_bytes: raw.size_bytes != null ? Number(raw.size_bytes) : fallback.size_bytes ?? null,
        width: raw.width != null ? Number(raw.width) : fallback.width ?? null,
        height: raw.height != null ? Number(raw.height) : fallback.height ?? null,
        category: String(raw.category ?? fallback.category ?? 'email'),
        tags: Array.isArray(raw.tags) ? (raw.tags as string[]) : fallback.tags,
        description: raw.description != null ? String(raw.description) : fallback.description ?? undefined,
    };
}

/** @deprecated Prefer `uploadUserMediaLibraryImage` from redux/userMedia/actions via useDispatchPromise. */
export { uploadUserMediaLibraryImage } from '../redux/userMedia/actions';
